import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ConvertToProposalDialog } from '../../../../components/Capture/ConvertToProposalDialog';
import { OutputHandoff } from '../../Outputs/OutputHandoff';
import { OutputsWorkspace } from '../../Outputs/OutputsWorkspace';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/** Outputs (Working papers): the outputs workspace and its proposal hand-off; `outputOwner` is preserved. */ export function OutputsSection() {
    const { captureProjectId, zouProjectId } = usePursuitRecord();
    const location = useLocation();
    const [convertOpen, setConvertOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(PursuitSectionFrame, {
        title: "Outputs",
        children: [
            /*#__PURE__*/ _jsx(OutputsWorkspace, {
                showTitle: false,
                captureProjectId: captureProjectId,
                zouProjectId: zouProjectId
            }, captureProjectId),
            /*#__PURE__*/ _jsx(OutputHandoff, {
                captureProjectId: captureProjectId,
                onOpenProposal: ()=>setConvertOpen(true)
            }, `${captureProjectId}:${location.search}`),
            /*#__PURE__*/ _jsx(ConvertToProposalDialog, {
                captureProjectId: captureProjectId,
                onOpenChange: setConvertOpen,
                open: convertOpen
            })
        ]
    });
}
